import { Component, OnInit, Inject } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { LookupInfo } from '../model/lookup.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { ProjectInfo } from '../model/project.model';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';

@Component({
  selector: 'app-lookup-management',
  templateUrl: './lookup-management.component.html',
  styleUrls: ['./lookup-management.component.css']
})


export class LookupManagementComponent implements OnInit {
  public body: string;
  LookupListPromise: Promise<LookupInfo[]>
  LookupList: LookupInfo[]
  LookupListPromisereturn: Promise<LookupInfo[]>[]

  txtSearchLookupType: string
  txtLookupType: string
  txtLookupValue: string

  titleModal: string

  hidLookupId: number

  // Zone pagination variable
  public currentPageNumber: number
  public LookupTotal: number
  public totalPages: number
  public environment: number

  ProjectTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;

  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;

  getreturn: Promise<string>;

  _ForK2: string;
  _EmpCode: string;

  noResultString: any;
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private GlobalService: GlobalService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {
    //Pagination
    this.currentPageNumber = 1;
    this.environment = environment.PageSize;
    

    //Initial 
    this.txtLookupType = "";
    this.txtLookupValue = "";
    this.LoadLookup();
    this.OnLoadCountLookupList();

    
  }

  btnClick_searchLookupList() {
    this.currentPageNumber = 1;
    this.noResultString = this.txtSearchLookupType;
    this.LoadLookup()
  }
  btnClick_clearLookupList() {
    this.txtSearchLookupType = null;
    this.LoadLookup();
  }

  LoadLookup() {
    this.LoadLookupList()
      .then(
        data => {
          this.LookupList = data
          this.hidcouchk = this.LookupList.length.toString();
        }
    );
    this.OnLoadLookupList()
  }
  async LoadLookupList(): Promise<LookupInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.environment;

      let objData = {};
      objData['LookupType'] = this.checkUndefinedString(this.txtSearchLookupType);
      objData['FlagDelete'] = "N";
      objData['rowFetch'] = this.environment;
      objData['rowOFFSet'] = offset;



      let strjson = JSON.stringify(objData);

      this.httpClient.post<LookupInfo[]>(this.baseurl + "lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.LookupList = data
        })

      return this.LookupListPromise;
    }
  }

  async LoadCountLookupList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let objData = {};
      objData['LookupType'] = this.checkUndefinedString(this.txtSearchLookupType);
      objData['FlagDelete'] = "N";

      let strjson = JSON.stringify(objData);


      return this.httpClient
        .post<number>(this.baseurl + "lookup/GetCountLookup",
          strjson, httpOptions)
        .toPromise();
    }
  }



  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  async btnClick_submitInsertLookup() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.OnCreating('y');
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };



      let strjson = "{" +
        "\"LookupType\": \"" + this.checkUndefinedString(this.txtLookupType) + "\", " +
        "\"LookupValue\": \"" + this.checkUndefinedString(this.txtLookupValue) + "\", " +

        "\"FlagDelete\": \"N\"" +
        "}";

      this.isSubmitted = this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/InsertLookup", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
          this.OnCreating('n');
        },
          () => {
            console.log("Insert = " + this.isSubmitted)
            this.OnCreating('n');
            $('#ModalCreateComplate').modal();
            this.LoadLookup();
          }
        );
    }
  }

  async btnClick_submitUpdateLookup(id) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.OnUpdating('y');
      id = this.hidLookupId
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson["LookupType"] = this.checkUndefinedString(this.txtLookupType);
      objectjson["LookupValue"] = this.checkUndefinedString(this.txtLookupValue);
      objectjson["FlagDelete"] = "N";
      objectjson["Id"] = id;

      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/UpdateLookup", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Update fail");
          this.OnUpdating('n');
        },
          () => {
            console.log("Update = " + this.isSubmitted);
            this.OnUpdating('n');
            $('#ModalUpdateComplate').modal();
            this.LoadLookup();
          }
        );
    }
  }

  btnClick_deleteLookup(id, auth_token): Observable<LookupInfo[]> {
  
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjsonCusInfo = "{" +
        "\"Id\": " + id + "" +
        "}";

      return this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/DeleteLookup", strjsonCusInfo, httpOptions);
    
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxlookup"]').prop('checked', check);

  }

  async btnClick_deleteLookupitem(id) {
   
    if (confirm("Are you sure you want to delete this Look up?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_deleteLookup(parseInt(id), auth_token).toPromise()
          .then(
            data => {
              console.log('หลังรับค่า');
              $('#ModalDeleteComplate').modal('show');
              this.LoadLookup();
            }
          );
      }
    }

  }

   async btnClick_onDeleteLookuList() {
     if (confirm("Are you sure you want to delete this Look up?")) {
       var auth_token = await this.TokenService.RefreshToken();
       if (!!auth_token) {
         var checkkedlookup = $('[name="checkboxlookup"]:checked');

         let num = checkkedlookup.length;
         let observableBatch = [];
         for (var i = 0; i < num; i++) {

           var lookupcurrent = <HTMLInputElement>checkkedlookup[i];
           observableBatch.push(this.btnClick_deleteLookup(parseInt(lookupcurrent.value), auth_token).toPromise().then(val => {
           }));

         }

         Promise.all(observableBatch).then(val => {
           console.log('สำเร็จ');
           $('#ModalDeleteComplate').modal('show');
           this.LoadLookup();
         });

       }
     }
  }


  btnClick_onCreateLookup() {
    this.titleModal = "Create";
    $('#ModalLookup').modal('show');
    this.txtLookupType = "";
    this.txtLookupValue = "";
    this.isOnUpdate = false

  }


  btnClick_onUpdateLookup(id) {

    $('#ModalLookup').modal('hide');
    this.titleModal = "Update";

    this.isOnUpdate = true

    let index = this.LookupList.findIndex(x => x.Id == id);

    this.txtLookupType = this.LookupList[index].LookupType != null ? this.LookupList[index].LookupType : null
    this.txtLookupValue = this.LookupList[index].LookupValue != null ? this.LookupList[index].LookupValue : null

    this.hidLookupId = this.LookupList[index].Id

    $('#ModalLookup').modal();

  }

  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitlookup").hide();
      $("#txtLookupType").prop('disabled', true);
      $("#txtLookupValue").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitlookup").show();
      $("#txtLookupType").removeAttr('disabled');
      $("#txtLookupValue").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');   
      $('#ModalLookup').modal('hide');
    }

  }

  OnUpdating(flag) {
    if (flag == 'y') {
      $("#loadingupdate").show();
      $("#btnsubmitlookup").hide();
      $("#txtLookupType").prop('disabled', true);
      $("#txtLookupValue").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingupdate").hide();
      $("#btnsubmitlookup").show();
      $("#txtLookupType").removeAttr('disabled');
      $("#txtLookupValue").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalLookup').modal('hide');
    }

  }


  //For Pagination
  LoadLookupUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
  }

  OnLoadLookupList(traget = null) {
    
    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadLookupUpdatePagination(traget);
    }

    
    this.LoadLookupList().then(data => { //call function load ticket list on hand current role user
      this.LookupList = data;
    })
    this.OnLoadCountLookupList()
  }

  OnLoadCountLookupList() {
    //call function load count all ticket list on hand current role user
    this.LoadCountLookupList().then(data => {
      this.LookupTotal = data;
      if(this.LookupTotal == 0){
        this.currentPageNumber = 0;
      }
      this.totalPages = Math.ceil(this.LookupTotal / environment.PageSize);

    })
  }

}
